/**
 * @generated SignedSource<<45e0784837e76ad418d6c5a06a38ad61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpcomingCountdown_game$data = {
  readonly unlockTimeTz: any;
  readonly " $fragmentType": "UpcomingCountdown_game";
};
export type UpcomingCountdown_game$key = {
  readonly " $data"?: UpcomingCountdown_game$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpcomingCountdown_game">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpcomingCountdown_game",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unlockTimeTz",
      "storageKey": null
    }
  ],
  "type": "Game",
  "abstractKey": null
};

(node as any).hash = "c1c3c052ded7f6a37593ff980b33c14a";

export default node;
